import { render } from "./product.vue?vue&type=template&id=2dc181b2"
import script from "./product.vue?vue&type=script&lang=js"
export * from "./product.vue?vue&type=script&lang=js"

import "./product.vue?vue&type=style&index=0&id=2dc181b2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__